import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, Row, Tab, Col } from 'react-bootstrap';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import * as ProjectActionType from '../constants';
import * as AuthActionType from 'Auth/constants';
import * as RegionMarketActionType from 'Region-Market/constants';
import { ProjectAddEditInformation } from './project-add-edit-information';
import AddIndividualLot from 'Lots/Containers/add-individual-lot';
import AddModel from 'Model/Containers/add-model';
import ProjectAddEditPhase from './project-add-edit-phase';
import AddEditAssignee from './project-add-edit-settings';
import AssignProjectCoordinator from './project-add-edit-coordinator';
import ProjectDocument from './project-add-edit-home-document';
import ProjectAddEditImport from './project-add-edit-import';
import HomeInventory from './project-add-edit-home-inventory';
import '../project.scss';
import Translate from 'components/translate';
import auth from 'Auth/authenticator';
import { AppSettings } from '../../constants';
import ProjectTemplates from './project-add-edit-templates';
import { Dropdown } from 'components/Dropdown/Dropdown';
import queryString from 'query-string';
import {get} from 'lodash';
import MaintenanceSchedule from './project-add-edit-maintenance-schedule';

const toolSelectOptions = [{text: 'PROJECT TOOLS', value: 'projectTools'}, {text: 'LOT TOOLS', value: 'lotTools'}];
class ProjectAddEdit extends Component {
  static propTypes = {
    match: PropTypes.object,
    dispatch: PropTypes.func,
    IsSuccessStep1: PropTypes.bool,
    SelectListRegions: PropTypes.array,
    history: PropTypes.object,
    location: PropTypes.object,
    ProjectStore: PropTypes.object,
    SelectListMarkets: PropTypes.any,
    builderUserList: PropTypes.any,
    UserProfile: PropTypes.object
  };
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      isBackProjectList: false,
      isRedirectToEdit: false,
      isRedirected: false,
      IsSuccessStep1: this.props.ProjectStore.IsSuccessStep1,
      projectId: this.props.match.params.projectId
        ? this.props.match.params.projectId
        : '',
      isNew: !this.props.match.params.projectId,
      toolSelection: {text: 'Project tools', value: 'projectTools'},
      active: queryParams.get('active')
        ? queryParams.get('active')
        : 'info',
      lotActive: queryParams.get('lotActive')
        ? queryParams.get('lotActive')
        : 'project-documents'
    };
  }

  componentDidMount() {
    const { projectId } = this.state;
    if (projectId) {
      this.props.dispatch({
        type: ProjectActionType.GET_PROJECT_BY_ID_ASYNC,
        params: projectId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { projectId, isNew } = this.state;
    if (nextProps.match.params.projectId && isNew) {
      this.setState({ isNew: false });
    }

    if (nextProps.location.search !== this.props.location.search) {
      const queryParams = new URLSearchParams(nextProps.location.search);
      this.setState({
        active: queryParams.get('active') ? queryParams.get('active') : this.state.active,
        lotActive: queryParams.get('lotActive') ? queryParams.get('lotActive') : this.state.lotActive
      });
    }

    // if (nextProps.ProjectStore.IsSuccessStep1 && !this.state.IsSuccessStep1) {
    //   this.setState({
    //     IsSuccessStep1: nextProps.ProjectStore.IsSuccessStep1
    //   }, () => {
    //     this.props.dispatch({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    //   });
    // }

    if (
      !isEqual(
        nextProps.ProjectStore.ProjectProfile,
        this.props.ProjectStore.ProjectProfile
      ) &&
      this.state.isRedirectToEdit &&
      !this.state.isRedirected
    ) {
      this.props.history.push(
        `/projects/edit/${nextProps.ProjectStore.ProjectProfile.id}`
      );
      this.setState({
        isRedirected: true,
        projectId: nextProps.ProjectStore.ProjectProfile.id
      });
    }

    if (nextProps.match.params.projectId !== projectId && projectId) {
      this.setState({ projectId: nextProps.match.params.projectId });
    }
  }

  componentWillUnmount() {
    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });

    this.setState({
      isBackProjectList: false,
      isRedirectToEdit: false,
      isRedirected: false
    });
  }

  onSubmit(e, data, projectActionType, isRedirectToEdit) {
    this.setState({ isRedirectToEdit: isRedirectToEdit });

    this.props.dispatch({
      type: projectActionType,
      params: data
    });
  }

  onBindingRegion() {
    this.props.dispatch({
      type: RegionMarketActionType.GET_LIST_REGION_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  }

  onBindingMarket(regionId) {
    this.props.dispatch({
      type: RegionMarketActionType.GET_LIST_MARKET_BY_REGION_ASYNC,
      params: {
        RegionIds: regionId,
        searchKey: '',
        selectedValue: ''
      }
    });
  }

  onBindingAccount() {
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  }

  handleChange(tags) {
    this.setState({ tags });
  }

  onSelectTab = selectedKey => {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?active=${selectedKey}`
    });
  };

  onSelectLotTab = selectedKey => {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?lotActive=${selectedKey}`
    });
  }

  onChange = (e) => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);
    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        projectTab: queryParams.projectTab,
        lotTab: queryParams.lotTab,
        toolSelection: e.value.value
      })
    });
  }

  onTabChange = (tabName) => (key) => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);
    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        ...queryParams,
        [tabName]: key
        // inventoryId: null,
        // categoryId: null
      })
    });
  }

  renderProjectTab = () => {
    const { projectId } = this.state;
    const { location } = this.props;
    const queryParams = queryString.parse(location.search);
    const roleName = auth.getRoleName();
    return (
      <Tab.Container id='project-tab' defaultActiveKey='info'
        activeKey={queryParams.projectTab}
        onSelect={this.onTabChange('projectTab')}
      >
        <Row className='clearfix' style={{ padding: '20px 15px' }}>
          <Col sm={12}>
            <Nav bsStyle='tabs' onSelect={this.onSelectTab}>
              <NavItem eventKey='info'>
                <Translate translateKey='project' capitalize />{' '}
                      information
              </NavItem>
              <NavItem eventKey='import'>Import</NavItem>
              <NavItem eventKey='phase'>
                <Translate translateKey='phase' plurals capitalize />
              </NavItem>
              <NavItem eventKey='plans'>Plans</NavItem>
              <NavItem eventKey='lots'>
                <Translate translateKey='lot' plurals capitalize />
              </NavItem>
              {(roleName === AppSettings.BUILDER_SUPER_ADMIN ||
                      roleName === AppSettings.BUILDER_ADMIN) && (
                  <NavItem eventKey='project-coordinators'>
                        Coordinators
                  </NavItem>
                )}
              <NavItem eventKey='project-settings'>Settings</NavItem>
              <NavItem eventKey='project-template'>Templates</NavItem>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content animation>
              <Tab.Pane eventKey='info'>
                <ProjectAddEditInformation
                  ref={c => {
                    this.projectInformation = c;
                  }}
                  selectListRegions={this.props.SelectListRegions}
                  selectListMarkets={this.props.SelectListMarkets}
                  selectListAccounts={this.props.builderUserList}
                  errorMsg={this.props.ProjectStore.ErrorMsg}
                  isCreate={projectId ? false : true}
                  onBindingRegion={this.onBindingRegion.bind(this)}
                  onBindingMarket={this.onBindingMarket.bind(this)}
                  onBindingAccount={this.onBindingAccount.bind(this)}
                  onSubmit={this.onSubmit.bind(this)}
                  item={this.props.ProjectStore.ProjectProfile}
                  sso={this.props.UserProfile.sso}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='import'>
                <ProjectAddEditImport
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='phase'>
                <ProjectAddEditPhase
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='plans'>
                <AddModel
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='lots'>
                <AddIndividualLot
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
              {((
                roleName === AppSettings.BUILDER_SUPER_ADMIN) ||
                      roleName === AppSettings.BUILDER_ADMIN) && (
                  <Tab.Pane eventKey='project-coordinators'>
                    <AssignProjectCoordinator
                      match={this.props.match}
                      projectId={this.state.projectId}
                      history={this.props.history}
                    />
                  </Tab.Pane>
                )}
              <Tab.Pane eventKey='project-settings'>
                <AddEditAssignee
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='project-template'>
                <ProjectTemplates
                  match={this.props.match}
                  projectId={this.state.projectId}
                  history={this.props.history}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }

  renderLotTab = () => {
    const { projectId } = this.state;
    const { location, match,history } = this.props;
    const queryParams = queryString.parse(location.search);
    return (
      <Tab.Container id='project-tab' defaultActiveKey='project-documents'
        activeKey={queryParams.lotTab}
        onSelect={this.onTabChange('lotTab')}
      >
        <Row className='clearfix' style={{ padding: '20px 15px' }}>
          <Col sm={12}>
            <Nav bsStyle='tabs' onSelect={this.onSelectLotTab}>
              <NavItem eventKey='project-documents'>Home Documents</NavItem>
              <NavItem eventKey='home-inventory'>Home Inventory</NavItem>
              <NavItem eventKey='home-maintenance'>Home Maintenance</NavItem>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content animation unmountOnExit>
              <Tab.Pane eventKey='project-documents'>
                <ProjectDocument
                  match={match}
                  projectId={projectId}
                  history={history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='home-inventory'>
                <HomeInventory
                  match={match}
                  projectId={projectId}
                  history={history}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='home-maintenance'>
                <MaintenanceSchedule
                  projectId={projectId}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }

  render() {
    const {projectId} = this.state;
    const {location} = this.props;
    const queryParams = queryString.parse(location.search);
    const toolSelection = toolSelectOptions.find(item => item.value === get(queryParams, 'toolSelection', 'projectTools'));
    const breadcrumbs = [
      {
        title: (
          <span>
            <Translate translateKey='project' plurals capitalize />
          </span>
        ),
        url: '/projects'
      },
      {
        title: this.state.isNew ? (
          <span>
            Add new <Translate translateKey='project' />
          </span>
        ) : (
          <span>{this.props.ProjectStore.ProjectProfile.name}</span>
        ),
        url: ''
      }
    ];

    return (
      <div>
        <div className='page-title'>
          <h2>
            {this.state.isNew ? (
              <span>
                Add new <Translate translateKey='project' />
              </span>
            ) : (
              this.props.ProjectStore.ProjectProfile.name
            )}
          </h2>
        </div>
        <div className='tool-selection-dropdown row'>
          <div className='project-breadcrumbs col-md-10 col-sm-10 col-xs-6'>
            <Breadcrumb breadcrumbs={breadcrumbs} />
          </div>
          <div className='select-tab-project-lot-tools col-md-2 col-sm-2 col-xs-6'>
            <div className='dropdown-select-tools'>
              <Dropdown
                defaultValue={toolSelectOptions[0]}
                onChange={this.onChange}
                className='filestring-dropdown filter-dropdown'
                value={toolSelection}
                options={toolSelectOptions}
                optionLabel='text'
                placeholder='-- Please select'
                style={{width: '100%'}}
                ref={ref => {
                  this.project = ref;
                }} />
            </div>
          </div>
        </div>
        <div className='wrapper box-form-siteone'>
          {!projectId && (
            <p
              className='s1-form-header description no-margin'
              style={{
                padding: '24px 16px',
                borderBottom: '1px solid #d8d8d8'
              }}
            >
              <Translate translateKey='project' capitalize /> information
            </p>
          )}
          {projectId && toolSelection.value === 'projectTools' && (this.renderProjectTab())}
          {projectId && toolSelection.value === 'lotTools' && (this.renderLotTab())}
          {!projectId && (
            <ProjectAddEditInformation
              ref={c => {
                this.projectInformation = c;
              }}
              selectListRegions={this.props.SelectListRegions}
              selectListMarkets={this.props.SelectListMarkets}
              selectListAccounts={this.props.builderUserList}
              errorMsg={this.props.ProjectStore.ErrorMsg}
              isCreate={projectId ? false : true}
              onBindingRegion={this.onBindingRegion.bind(this)}
              onBindingMarket={this.onBindingMarket.bind(this)}
              onBindingAccount={this.onBindingAccount.bind(this)}
              onSubmit={this.onSubmit.bind(this)}
              item={this.props.ProjectStore.ProjectProfile}
              sso={this.props.UserProfile.sso}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    builderUserList: state.authReducer.builderUserList,
    ProjectStore: state.ProjectStore,
    SelectListRegions: state.RegionMarketStore.SelectListRegions,
    SelectListMarkets: state.RegionMarketStore.SelectListMarkets,
    UserProfile: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(ProjectAddEdit);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit.js